<template>
  <v-row>
    <v-col>
      <!-- not api -->
      <v-expansion-panels flat accordion class="menu-expandable-bg" v-if="!api">
        <template v-for="(item, i) in items">
          <v-expansion-panel :key="i" class="menu-expandable">
            <v-expansion-panel-header
              class="px-0 py-5 tcdc-panel-header cursor-pointer"
              @click="() => onClick(item)"
            >
              <span class="text-uppercase tcdc-menu-title bold menu-highlight">{{ $t(item.name) }}</span>
              <template v-slot:actions>
                <v-icon class="white--text" size="medium" v-if="item.subMenuList">mdi-plus</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <template v-for="(item, index) of item.subMenuList">
                <div
                  :key="index"
                  class="text-capitalize tcdc-menu-content bold"
                  style="font-family: Poppins, Kanit"
                  @click="onClickSubMenu(item)"
                >{{ $t(item.name) }}</div>
              </template>
            </v-expansion-panel-content>
            <MenuDivider />
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
      <!-- from API data -->
      <v-expansion-panels flat accordion class="menu-expandable-bg" v-else>
        <template v-for="(item, i) in items">
          <v-expansion-panel :key="i" class="menu-expandable">
            <v-expansion-panel-header
                    class="px-0 py-5 tcdc-panel-header cursor-pointer"
                    @click="() => onClick(item)"
            >
              <span class="text-uppercase tcdc-menu-title bold menu-highlight">{{ item[`title_${lang}`] }}</span>
              <template v-slot:actions>
                <v-icon class="white--text" size="medium" v-if="item.branches && item.branches.length > 0">mdi-plus</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <template v-for="(item, index) of item.branches">
                <div
                        :key="index"
                        class="text-capitalize tcdc-menu-content bold"
                        style="font-family: Poppins, Kanit"
                        @click="() => onClickSubMenu(item)"
                >{{ item[`branch_name_${lang}`] }}</div>
              </template>
            </v-expansion-panel-content>
            <MenuDivider />
          </v-expansion-panel>
        </template>
      </v-expansion-panels>

      <template v-if="optional.length > 0">
        <v-expansion-panel v-for="(item, i) in optional" :key="i" class="menu-expandable">
          <v-expansion-panel-header
              class="px-0 py-5 tcdc-panel-header cursor-pointer"
              @click="() => onClick(item)"
          >
            <span class="text-uppercase tcdc-menu-title bold menu-highlight">{{ $t(item.name) }}</span>
            <template v-slot:actions>
              <v-icon class="white--text" size="medium" v-if="item.subMenuList && item.subMenuList.length > 0">mdi-plus</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <template v-for="(item, index) of item.subMenuList">
              <div
                  :key="index"
                  class="text-capitalize tcdc-menu-content bold"
                  style="font-family: Poppins, Kanit"
                  @click="() => onClickSubMenu(item)"
              >{{ item[`branch_name_${lang}`] }}</div>
            </template>
          </v-expansion-panel-content>
          <MenuDivider />
        </v-expansion-panel>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import MenuDivider from "../dividers/MenuDivider";
import { mapState } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array
    },
    api: {
      type: Boolean,
      default: false
    },
    optional: {
      default: () => []
    }
  },
  components: {
    MenuDivider
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  },
  methods: {
    onClick(item) {
      this.$emit("onClick", item);
    },
    onClickSubMenu(item) {
      // console.log(item)
      this.$emit("onClickSubMenu", item);
    }
  }
};
</script>

<style>
.menu-expandable-bg {
  background-color: black !important;
}
</style>
